module.exports = __webpack_public_path__ + "static/media/da.92cf611e.jpg";